import React from 'react';
import Weblayout from './Weblayout';
import PageTransition from '../components/PageTransition';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { appname } from "../variables";

export default function Refund() {
  const navigate = useNavigate();

  return (
    <PageTransition>
      <Weblayout isLegal={true}>
        <motion.div 
          initial={{ opacity: 0, scale: 0.98 }}
          animate={{ opacity: 1, scale: 1 }}
          className="bento-item p-0 border-0 bg-white overflow-hidden d-flex flex-column h-100 shadow-lg"
          style={{ borderRadius: '24px' }}
        >
          {/* HEADER SECTION */}
          <div className="bg-light border-bottom p-4 flex-shrink-0 d-flex justify-content-between align-items-center">
            <div>
              <h2 className="fw-black text-dark m-0">Return & Refund Policy</h2>
              <small className="text-muted font-monospace">REFUND_PROTOCOL_V4.0</small>
            </div>
            <div className="badge bg-warning bg-opacity-10 text-warning border border-warning border-opacity-25 px-3 py-2">
              <i className="bi bi-arrow-left-right me-1"></i> TRANSACTION_POLICY
            </div>
          </div>

          {/* SCROLLABLE CONTENT BODY */}
          <div className="p-4 p-md-5 overflow-auto text-dark privacy-content flex-grow-1">
            
            <section className="mb-5">
              <h6 className="font-monospace text-primary fw-bold mb-2">01_DIGITAL_NATURE</h6>
              <h4 className="fw-black text-dark mb-3">Digital Service Policy</h4>
              <p>
                Since {appname} provides non-tangible, irrevocable digital services (API access and Cloud Node hosting), <strong>we do not issue refunds</strong> once the order is accomplished and the service is activated.
              </p>
              <p className="text-muted small">
                As a customer, you are responsible for understanding this upon purchasing any subscription plan on our site.
              </p>
            </section>

            

            <section className="mb-5">
              <h6 className="font-monospace text-primary fw-bold mb-2">02_REFUND_EXCEPTIONS</h6>
              <h4 className="fw-black text-dark mb-3">Exceptional Circumstances</h4>
              <p>While we maintain a strict no-refund policy, we may consider requests under the following conditions:</p>
              <ul className="list-group list-group-flush border-start border-warning border-4 ms-2">
                <li className="list-group-item border-0"><strong>Non-delivery of Service:</strong> If our system fails to provision your node within 24 hours of payment.</li>
                <li className="list-group-item border-0"><strong>Major Defects:</strong> If the API is completely non-functional due to our server faults (excluding Meta/WhatsApp downtime).</li>
                <li className="list-group-item border-0"><strong>Duplicate Payment:</strong> If you were charged twice for the same transaction due to a gateway error.</li>
              </ul>
            </section>

            <section className="mb-5">
              <h6 className="font-monospace text-primary fw-bold mb-2">03_CANCELLATION</h6>
              <h4 className="fw-black text-dark mb-3">Subscription Cancellation</h4>
              <p>
                You may cancel your subscription at any time via your dashboard. Upon cancellation, you will retain access to your nodes until the end of your current billing cycle. <strong>No pro-rated refunds</strong> are provided for unused days within a cycle.
              </p>
            </section>

            <section className="mb-5">
              <h6 className="font-monospace text-primary fw-bold mb-2">04_WHATSAPP_BAN_CLAUSE</h6>
              <h4 className="fw-black text-dark mb-3">Account Suspensions</h4>
              <p>
                {appname} is not responsible for numbers or accounts banned by Meta/WhatsApp for violating their spam policies. No refunds will be issued if your WhatsApp account is restricted due to your messaging activities.
              </p>
            </section>

            <section className="mb-4">
              <div className="p-4 rounded-4 bg-light border text-dark d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 text-center text-md-start">
                <div>
                  <h5 className="fw-bold m-0">Need to file a request?</h5>
                  <small className="text-muted">Requests must be submitted within 7 days of the transaction.</small>
                </div>
                <button className="btn btn-dark rounded-pill px-4 fw-bold" onClick={() => navigate('/contact')}>
                  SUBMIT_TICKET
                </button>
              </div>
            </section>

          </div>
        </motion.div>
      </Weblayout>
    </PageTransition>
  );
}